import React from "react";
import {Radio} from "antd";
import {injectIntl} from "react-intl";
import Constants from "../../../services/Constants";

import './FuelTypeSelector.css'
import FieldError from "../input/FieldError";

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

class FuelTypeSelector extends React.Component {

  render() {
    const {intl:{formatMessage}, error, value, onChange, ...attributes} = this.props;

    return (
      <span className={error ? ' error' : ''}>
        <RadioGroup value={value} onChange={onChange} {...attributes}>
          <RadioButton value={Constants.FUEL_TYPE_DIESEL.value}>{formatMessage(Constants.FUEL_TYPE_DIESEL.label)}</RadioButton>
          <RadioButton value={Constants.FUEL_TYPE_GASOLINE.value}>{formatMessage(Constants.FUEL_TYPE_GASOLINE.label)}</RadioButton>
          <RadioButton value={Constants.FUEL_TYPE_ELECTRIC.value}>{formatMessage(Constants.FUEL_TYPE_ELECTRIC.label)}</RadioButton>
          <RadioButton value={Constants.FUEL_TYPE_HYBRID.value}>{formatMessage(Constants.FUEL_TYPE_HYBRID.label)}</RadioButton>
        </RadioGroup>

        {error && (
          <FieldError error={error}/>
        )}
      </span>
    )
  }
}

export default injectIntl(FuelTypeSelector);



// WEBPACK FOOTER //
// ./src/components/common/select/FuelTypeSelector.js